export default "assets/images/icons/newsletter-909b9e76.svg";